import React, { useRef } from "react";
import Button from "components/button/Button";
import { RECEIPT_PROMO_IMAGE_SIZE_HINT } from "util/receiptPromoDefaults";

const emptyAd = () => ({
  advertisementId: null,
  promotionalProductName: "",
  advertisementImageLink: "",
  advertisementImage: "",
  advertisementImages: null,
  previewUrl: null,
  default: false
});

export default function ReceiptPageAdvertisementEditor({
  ads,
  onChange,
  deleteIds = [],
  onDeleteIdsChange
}) {
  const fileRefs = useRef({});
  const safeAds = ads || [];

  const updateAd = (index, patch) => {
    onChange(safeAds.map((ad, i) => (i === index ? { ...ad, ...patch } : ad)));
  };

  const addAd = () => {
    onChange([...safeAds, emptyAd()]);
  };

  const removeAd = index => {
    const ad = safeAds[index];
    if (ad?.advertisementId && onDeleteIdsChange) {
      onDeleteIdsChange([...(deleteIds || []), ad.advertisementId]);
    }
    onChange(safeAds.filter((_, i) => i !== index));
  };

  const handleImageChange = (index, file) => {
    if (!file) return;
    const previewUrl = URL.createObjectURL(file);
    updateAd(index, {
      advertisementImages: file,
      previewUrl,
      advertisementImage: previewUrl
    });
  };

  const setDefault = index => {
    onChange(
      safeAds.map((ad, i) => ({
        ...ad,
        default: i === index
      }))
    );
  };

  return (
    <div>
      <h4 className="fs-16 bold-text mt-20 mb-12">Special offers</h4>
      <p className="text-muted fs-13 mb-8">
        Promotional ads shown on the QR receipt page. Mark one as default to
        always display when no product match is found.
      </p>
      <p className="text-muted fs-13 mb-15">
        {RECEIPT_PROMO_IMAGE_SIZE_HINT} Multiple offers appear as a swipeable
        slider on mobile.
      </p>

      {safeAds.map((ad, index) => (
        <div
          key={ad.advertisementId || `new-${index}`}
          className="mb-10 roe-card-style"
        >
          <div className="roe-card-body mt-10">
            <label className="fs-16 medium-text">
              Advertisement {index + 1}
            </label>

            <div className="form-group">
              <label className="fs-14 medium-text">
                <input
                  type="checkbox"
                  checked={!!ad.default}
                  onChange={() => setDefault(index)}
                />{" "}
                Default offer
              </label>
            </div>

            <div className="form-group">
              <label className="fs-14 medium-text">Product name</label>
              <input
                className="form-control react-form-input"
                value={ad.promotionalProductName}
                placeholder="Promotional product name"
                onChange={e =>
                  updateAd(index, { promotionalProductName: e.target.value })
                }
              />
            </div>

            <div className="form-group">
              <label className="fs-14 medium-text">Click-through link</label>
              <input
                className="form-control react-form-input"
                value={ad.advertisementImageLink}
                placeholder="https://..."
                onChange={e =>
                  updateAd(index, { advertisementImageLink: e.target.value })
                }
              />
            </div>

            <div className="form-group">
              <label className="fs-14 medium-text">Offer image</label>
              <p className="text-muted fs-12 mb-8">
                {RECEIPT_PROMO_IMAGE_SIZE_HINT}
              </p>
              <input
                ref={el => {
                  fileRefs.current[index] = el;
                }}
                type="file"
                accept="image/jpg,image/png,image/jpeg"
                style={{ display: "none" }}
                onChange={e => handleImageChange(index, e.target.files?.[0])}
              />
              <Button
                className="c-btn c-info"
                onClick={() => fileRefs.current[index]?.click()}
              >
                Upload image
              </Button>
              {(ad.previewUrl || ad.advertisementImage) && (
                <img
                  src={ad.previewUrl || ad.advertisementImage}
                  alt=""
                  className="mt-15"
                  style={{
                    width: "100%",
                    maxWidth: "320px",
                    aspectRatio: "16 / 9",
                    objectFit: "cover",
                    borderRadius: "8px",
                    background: "#e2e8f0",
                    display: "block"
                  }}
                />
              )}
            </div>

            <Button className="c-btn c-danger" onClick={() => removeAd(index)}>
              Remove
            </Button>
          </div>
        </div>
      ))}

      <Button className="c-btn c-info mb-10" onClick={addAd}>
        Add advertisement
      </Button>
    </div>
  );
}
